// extracted by mini-css-extract-plugin
export default {"form":"Documentation_form__F+I-T"};